export const validarDNI = (dni) => {
  if (!dni) return { valido: false, tipo: null };

  const dniClean = dni.toUpperCase().trim();
  const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';

  // NIE español
  if (/^[XYZ]\d{7}[A-Z]$/.test(dniClean)) {
    const reemplazado = dniClean
      .replace('X', '0')
      .replace('Y', '1')
      .replace('Z', '2');
    const numero = reemplazado.slice(0, 8);
    const letra = reemplazado[8];
    const valido = letras[numero % 23] === letra;
    return { valido, tipo: valido ? 'NIE' : null };
  }

  // DNI español
  if (/^\d{8}[A-Z]$/.test(dniClean)) {
    const numero = dniClean.slice(0, 8);
    const letra = dniClean[8];
    const valido = letras[numero % 23] === letra;
    return { valido, tipo: valido ? 'DNI' : null };
  }

  // Pasaporte extranjero
  if (/^[A-Z0-9]{7,15}$/.test(dniClean)) {
    return { valido: true, tipo: 'PASAPORTE' };
  }

  return { valido: false, tipo: null };
};
